import { removeItem } from '@Utils/LocalStorage';
import { USER_STATE_LOCAL_STORAGE_KEY } from './Constants';

const removeUserInLocalStorage = () => removeItem(USER_STATE_LOCAL_STORAGE_KEY);

export { removeUserInLocalStorage };
